<template>
  <div class="mb-3">
    <h4 class="mb-1">{{ greeting }}, {{ firstName }}</h4>
    <p v-if="companyName" class="text-muted mb-0">{{ companyName }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useEmployeeDashboardAccess } from "@/composables/useEmployeeDashboardAccess";

const { firstName, companyName } = useEmployeeDashboardAccess();

const greeting = computed(() => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
});
</script>
